<template>
  <div class="batchList">
    <el-select
      v-model="searchForm.province"
      placeholder="请选择所在省"
      class="searchSelect"
      @change="searchChange(1)"
      style="width: 190px"
    >
      <el-option
        v-for="item in provinceList"
        :key="item.regionId"
        :label="item.regionName"
        :value="item.regionId"
      ></el-option>
    </el-select>
    <el-select
      class="searchSelect"
      v-model="searchForm.city"
      placeholder="请选择所在市"
      @change="searchChange(2)"
      style="width: 190px"
    >
      <el-option
        v-for="item in cityList"
        :key="item.regionId"
        :label="item.regionName"
        :value="item.regionId"
      ></el-option>
    </el-select>
    <el-select
      class="searchSelect"
      v-show="showRegion"
      v-model="searchForm.area"
      placeholder="请选择所在区县"
      @change="searchChange(3)"
      style="width: 190px"
    >
      <el-option
        v-for="item in areaList"
        :key="item.regionId"
        :label="item.regionName"
        :value="item.regionId"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { queryDistrict, queryProvince } from "@/assets/js/caseRequest";
export default {
  props: {
    showRegion: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      provinceList: [],
      cityList: [],
      areaList: [],
      searchForm: {
        province: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        city: "",
        area: "",
      },
      form: {
        province: "",
        region: "",
        city: "",
      },
    };
  },
  mounted() {
    this.getProvince();
  },
  methods: {
    // 搜索省市
    async searchChange(type) {
      let regionId;
      if (type == 1) {
        regionId = this.searchForm.province;
        this.provinceList.map((item) => {
          if (item.regionId == regionId) {
            this.form.province = item.regionName;
            this.form.city = "";
            this.form.region = "";
            this.searchForm.city=''
            this.searchForm.region=''
            this.$emit("areaInfo", this.form);
          }
        });
      } else if (type == 2) {
        regionId = this.searchForm.city;
        this.cityList.map((item) => {
          if (item.regionId == regionId) {
            this.form.city = item.regionName;
            this.form.region = "";
            this.searchForm.region=''

            this.$emit("areaInfo", this.form);
          }
        });
      } else if (type == 3) {
        regionId = this.searchForm.area;
        this.areaList.map((item) => {
          if (item.regionId == regionId) {
            this.form.region = item.regionName;
            this.$emit("areaInfo", this.form);
          }
        });
      }
      let data = {
        currentTime: new Date().getTime(),
        regionParentId: regionId,
      };
      let res = await queryDistrict(data);
      if (res.code == 200) {
        if (type == 1) {
          this.cityList = res.data;
        } else if (type == 2) {
          this.areaList = res.data;
        }
      }
    },
    //获取省份
    async getProvince() {
      let data = {
        currentTime: new Date().getTime(),
      };

      let res = await queryProvince(data);

      if (res.code == 200) {
        this.provinceList = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}

.searchSelect {
  margin-right: 10px;
  // display: block;
  margin-bottom: 15px;
}
.searchSelect::nth-last-child() {
  margin-right: 0;
  margin-bottom: 0px;

}
</style>


// WEBPACK FOOTER //
// src/components/selectArea.vue